// src/services/ScrollService.ts
export class ScrollService {
  scrollTo(section: string): void {
    const el = document.getElementById(section);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  }

  scrollToSection(section: string): void {
    this.scrollTo(section);
  }
}

// Eine einzige Instanz exportieren (Singleton)
export const scrollService = new ScrollService();
